// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.

import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'
import { themeSelector } from './secondOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/system').TestingAndDiagnosis} TestingAndDiagnosis
 */

/**
 * @type {function(PlottrState): TestingAndDiagnosis}
 */
const testingAndDiagnosisSelector = createSelector(
  fullSystemStateSelector,
  ({ testingAndDiagnosis }) => {
    return testingAndDiagnosis ?? {}
  }
)

/**
 * @type {function(PlottrState): boolean}
 */
export const testingAndDiagnosisEnabledSelector = createSelector(
  testingAndDiagnosisSelector,
  ({ testingAndDiagnosisEnabled }) => {
    return testingAndDiagnosisEnabled
  }
)

/**
 * @type {function(PlottrState): boolean}
 */
export const isV2ComponentsEnabledSelector = createSelector(
  testingAndDiagnosisSelector,
  themeSelector,
  ({ v2 }, theme) => {
    return v2 || !!theme
  }
)
